import {
  Button,
  IconCloseBold,
  IconDownloadSimpleBold,
  Inline,
  Layout,
  ShortText,
  Stack,
  keyframes,
  pxToRem,
  styled,
} from '@lessonnine/design-system-rebranded.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

// TODO: if the AB test is sucessful, we should enquiry whether this should be a design-system component. It's likely other teams might need this
import AppLogo from '../../assets/images/AppLogo.svg';
import { DOWNLOAD_APP_BANNER_CLOSED } from '../../config/types/action.mjs';
import { getGoBaseUrl } from '../../utils/url.mjs';

const slideInBottom = keyframes`
  from {
    transform: translateY(110%);
  }
  to {
    transform: translateY(0);
  }
`;

const FloatingWrapper = styled.div`
  align-items: center;
  animation: ${slideInBottom} 1s ease-in-out;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 1;
`;

const Container = styled(Layout)`
  background-color: ${({ theme }) => theme.color.brand.surfaceLightened};
  border-radius: ${tokens.radius.large};

  /* TODO: it'd be better to use tokens here, but so far there are no shadow tokens in the DS so going for what the Figma had */
  box-shadow: 0 13px 12px 0 rgb(0 0 0 / 4%);
  max-width: ${pxToRem(280)};
  position: relative;

  @media (min-width: ${tokens.viewports.breakpoints.medium}) {
    max-width: ${pxToRem(928)};
  }
`;

const AppLogoImg = styled.img`
  height: 48px;
  width: 48px;

  @media (min-width: ${tokens.viewports.breakpoints.medium}) {
    height: 80px;
    width: 80px;
  }
`;

const CloseButton = styled(Button)`
  position: absolute;
  right: 2px;
  top: 2px;
`;

function DownloadAppBanner() {
  const dispatch = useDispatch();
  const textSize = { medium: 'large', small: 'xsmall' };
  const closeAppBanner = useCallback(() => {
    dispatch({ type: DOWNLOAD_APP_BANNER_CLOSED });
  }, [dispatch]);

  return (
    <FloatingWrapper>
      <Container
        align="spaceBetween"
        alignItems="center"
        direction={{ medium: 'inline', small: 'stack' }}
        gap={{ medium: tokens.space.x3, small: tokens.space.x4 }}
        padding={{ medium: tokens.space.x5, small: [tokens.space.x5, tokens.space.x3] }}
      >
        <Inline alignItems="center" gap={{ medium: tokens.space.x8, small: tokens.space.x3 }}>
          <AppLogoImg aria-hidden height={48} src={AppLogo} width={48} />
          <Stack>
            <ShortText size={textSize} weight="strong">
              Babbel is better in the app!
            </ShortText>
            <ShortText size={textSize}>Get the Magazine, games, podcasts and more free</ShortText>
          </Stack>
        </Inline>
        <Button
          alignIcon="end"
          as="a"
          color="primary-emphasis"
          fullWidth={{ medium: false, small: true }}
          icon={<IconDownloadSimpleBold />}
          href={`${getGoBaseUrl()}/floating-banner-cta/default`}
          onClick={closeAppBanner}
          size={{ medium: 'large', small: 'small' }}
          target="_blank"
        >
          Download now
        </Button>
        <CloseButton
          color="ghost"
          icon={<IconCloseBold />}
          onClick={closeAppBanner}
          size="small"
          title="Close"
        />
      </Container>
    </FloatingWrapper>
  );
}

export { DownloadAppBanner };
